import { createRootContextHook } from 'common/util/react';
export const useGlobalSidenavController = createRootContextHook("globalSidenavController");